module.exports = __webpack_public_path__ + "media/images/empty-star-sm-solid-068d0c45.svg";